import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { motion } from 'framer-motion'
import {lightTheme} from './Themes';
import { Design, Develope} from './AllSvgs';


import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'

const Box = styled(motion.main)`
background-color: ${props => props.theme.body};
width: 100vw;
min-height:100vh;
position: relative;
display: flex;
justify-content: space-evenly;
align-items: center;
flex-wrap: wrap;   /* ✅ allows wrapping */
gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;   /* ✅ stack vertically */
    height: auto;
    padding: 6rem 0 2rem 0;
  }
`

const pageTransition = {
    initial: { opacity: 0, y: 14 },
    animate: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.45, ease: 'easeOut' }
    },
    exit: {
        opacity: 0,
        y: -12,
        transition: { duration: 0.3, ease: 'easeIn' }
    }
}

const Main = styled.div`
border: 2px solid ${props => props.theme.text};
color: ${props => props.theme.text};
padding: clamp(1.1rem, 2vw, 2rem);
width: min(92vw, 30rem);
min-height: 26rem;
height: auto;
z-index:3;
line-height: 1.5;
cursor: default;

font-family: 'Ubuntu Mono',monospace;
display: flex;
flex-direction: column;
justify-content: space-between;
gap: 0.6rem;

&:hover{
    color: ${props => props.theme.body};
    background-color: ${props => props.theme.text};
   
}

@media (max-width: 50em) {
    min-height: auto;
}
`

const Title = styled.h2`
display: flex;
justify-content: center;
align-items: center;
font-size: clamp(1.1rem, calc(0.9rem + 1vw), 2rem);

${Main}:hover &{
    &>*{
        fill:${props => props.theme.body};
    }
}

&>*:first-child{
margin-right: 1rem;
}
`

const Description = styled.div`
color: ${props => props.theme.text};
font-size: clamp(0.95rem, calc(0.65em + 0.7vw), 1.1rem);
line-height: 1.6;
padding: 0.5rem 0;


${Main}:hover &{
   
        color:${props => props.theme.body};
    
}

strong{
    margin-bottom: 1rem;
    text-transform: uppercase;
}
ul,p{
    margin-left: 2rem;
}
`

const MySkillsPage = () => {
    return (
        <ThemeProvider theme={lightTheme}>
        <Box variants={pageTransition} initial="initial" animate="animate" exit="exit">

            <LogoComponent theme='light'/>
            <SocialIcons theme='light'/>
            <PowerButton />
            <ParticleComponent theme='light' />
            <Main>
                <Title>
                    <Develope width={40} height={40} /> Software Developer
                </Title>
                <Description>
                I enjoy writing clean code and creating useful products.
                </Description>
                <Description>
                <strong>I like to code in</strong>
                <p>
                Java, Python, Javascript, Node, MySQL, C & MongoDB
                </p>
                </Description>
                <Description>
                <strong>Tools</strong>
                <ul>
                    <li>
                        Eclipse
                    </li>
                    <li>
                        Pycharm
                    </li>
                </ul> 
                </Description>

            </Main>
            <Main>
                <Title>
                    <Design width={40} height={40} /> Full-Stack Developer
                </Title>
                <Description>
                I consider myself fortunate to be a Fullstack developer because my work has a direct impact on the user's life.
                </Description>
                <Description>
                <strong>Skills</strong>
                    <p>HTML, CSS, React, Bootstrap, REST API, Vite, Tailwind CSS, Firebase, Supabase, Zoho Catalyst</p>
                {/* <strong>Skills</strong>
                <ul>
                    <li>
                        Web Design
                    </li>
                    <li>
                        Mobile Apps
                    </li>
                </ul> */}
                </Description>
                <Description>
                <strong>Tools</strong>
                <p>VS Code, Git, GitHub, Postman, and related tooling.</p>
                {/* <ul>
                    <li>
                    Figma
                    </li>
                    
                </ul> */}
                </Description>
            </Main>
            <BigTitle text="SKILLS" top="80%" right="30%" />
        </Box>
        </ThemeProvider>
    )
}

export default MySkillsPage
